// extracted by mini-css-extract-plugin
export default {"gallery":"styles_gallery__weYcy","buttonsContainer":"styles_buttonsContainer__jtgQQ"};